/* src/app/user-authorizations/user-authorization-container/user-authorization-container.component.scss */
/*# sourceMappingURL=user-authorization-container.component.css.map */
